module.exports = __webpack_public_path__ + "img/img2.4cc8a14f.png";